import { render, staticRenderFns } from "./NextStop.vue?vue&type=template&id=5d4b51d6&scoped=true&"
import script from "./NextStop.vue?vue&type=script&lang=js&"
export * from "./NextStop.vue?vue&type=script&lang=js&"
import style0 from "./NextStop.vue?vue&type=style&index=0&id=5d4b51d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4b51d6",
  null
  
)

export default component.exports